import './App.css';

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Header from './componets/Header';
import HeroSection from './componets/HeroSlider';
import Footer from './componets/Footer';
import Aboutus from './componets/Aboutus';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ServicesSection from './pages/ServicesSection';
import Ourfleets from './pages/Ourfleets';
import Packages from './pages/Packages';
import Booking from './pages/Booking';
import Gallery from './pages/Gallery';
import ContactSection from './pages/ContactSection';
import Enquiry from './pages/Enquiry';
import OurNetwork from './pages/OurNetwork';
import Tempotravelleronrentinpune from './pages/Tempo Traveller On Rent in Pune';
import Punetoshirditempotraveller from './pages/Pune to Shirdi Tempo Traveller On Rent';
import Punetomahabaleshwar from './pages/Pune to Mahabaleshwar Tempo Traveller on Rent';
import Punetogoatempotraveller from './pages/Pune to Goa Tempo Traveller Hire';
import Punetomumbaitempotraveller from './pages/Pune to Mumbai Tempo Traveller on Rent';
import Punetokonkandarshantempo from './pages/Pune to Konkan Darshan Tempo Traveller Hire';
import Punetonashiktempotravelleer from './pages/Pune to Nashik Tempo Traveller On Rent';
import Tempotravelleronrentforpune from './pages/Tempo Traveller On Rent for Pune Darshan';
import Minibusonrentinpune from './pages/Mini Bus On Rent in Pune';
import Onethreeseatertempo from './pages/13 Seater Tempo Traveller On Rent in Pune';
import Onesevanseater from './pages/17 Seater Tempo Traveller on Rent in Pune';
import Twentyseaterluxurybusonrent from './pages/20 Seater Luxury Bus On Rent Pune';
import Twentisixseatertempotraveller from './pages/26 Seater Tempo Traveller On Rent in Pune';
import Thietintwoseaterluxurybusonrent from './pages/32 Seater Luxury Bus On Rent in Pune';
import Threefiveseaterbusonrentinpune from './pages/35 Seater Bus on Rent in Pune';
import Fourfiveseaterbusonrentinpune from './pages/45 Seater Bus On Rent in Pune';
import Fivezeroseaterbusonrentinpune from './pages/50 Seater Bus On Rent in Pune';
import Bushireforschooltripinpune from './pages/Bus Hire for School Trips in Pune';
import Busbookingforweddinginpune from './pages/Bus booking for Wedding in Pune';
import Busbookingformarriage from './pages/Bus Booking for Marriage in Pune';
import Busserviceforcorporateinpune from './pages/Bus Service for Corporate in Pune';
import Busonrentforeventinpune from './pages/Bus on Rent For Event in Pune';
import Bushireforoutstationinpune from './pages/Bus Hire for Outstation in Pune';
import Acbusonrentinpune from './pages/AC Bus On Rent in Pune';
import Punebushirerrentalservice from './pages/Pune Bus Hire Rental Service';
import Nonacbusrentalserviceinpune from './pages/Non Ac Bus Rental Service in Pune';
import Busserviceforpicniicinpune from './pages/Bus Service for Picnic in Pune';
import Punetoaurangabadtempotraveller from './pages/Pune to Aurangabad Tempo Traveller on Rent';
import Ashtavinayakdarshantourbuspackage from './pages/Ashtavinayak Darshan Tour Bus Package From Pune';
import Punetorajshtanbustrippackage from './pages/Pune to Rajasthan Bus Trip Package';
import Punetogijratbushirepackage from './pages/Pune to Gujarat Bus Hire Package';
import Goatourpackagefrompune from './pages/Goa Tour Package From Pune by Bus';
import Punetouttarpradeshbusonrent from './pages/Pune to Uttar Pradesh Bus On Rent';
import Bookkonkandarshantourpackage from './pages/Book Konkan Darshan Tour Packages from Pune by Bus';
import Localbushireinpune from './pages/Local Bus Hire In Pune';
import Punetolonavalabustourpackage from './pages/Pune to Lonavala Bus Tour Package';
import Punetonashikbusonrentpackage from './pages/Pune to Nashik Bus on Rent Packages';
import Luxuryontwoseater from './pages/Luxury 12,14,17 Seater Tempo Traveller in Pune';
import Bushirefortoristinpune from './pages/Bus Hire for Tourist in Pune';
import Punetosinhagadfortbusonrent from './pages/Pune to Sinhagad Fort Bus on rent in Pune';
import Punetobhimashankarjtotilinga from './pages/Pune to Bhimashankar Jyotirlinga bus on Rent';
import Punetokolhapurtempo from './pages/Pune to Kolhapur Tempo Traveller Rent';
import Punetomumbaibushirefortour from './pages/Pune to Mumbai Bus Hire for Tour Package From Pune';
import Sadeteenshaktipeethtourfrom from './pages/Sade Teen Shakti Peeth Tour From Pune by bus Package';
import Punetomatherantempotraveller from './pages/Pune To Matheran Tempo Traveller Hire On Rent';
import Actempotravelleronrent from './pages/Ac Tempo Traveller On Rent in Pune';
import Bushireinpuneforoutstationandlocal from './pages/Bus Hire in Pune for Outstation and Local Trip';
import Bookbusonrentinpune from './pages/Book Bus On Rent in Pune';
import Bharatbenzbusonrentinpune from './pages/Bharat Benz Bus On Rent in Pune';
import Eicherbusonrentinpune from './pages/Eicher Bus on Rent in Pune';
import Punetomahabaleshwarcabpackage from './pages/Pune to Mahabaleshwar Cab Package';
import Punetobhimashankarcabpackage from './pages/Pune to Bhimashankar Cab Package';
import Punetokonkankadarshancabs from './pages/Pune to Konkan Darshan Cabs';
import Onlinecabbookingpune from './pages/Online Cab Booking Pune';
import Innovacrystacabbookinginpune from './pages/Innova Crysta Cab Booking in Pune';
import Ashtavinayakdarshancab from './pages/Ashtavinayak Darshan Cab Pune';
import Punetolonavalacabservice from './pages/Pune to Lonavala Cab Service';
import Punetooutstationcabspackages from './pages/Pune to Outstation Cabs Package';
import Ertigacabhireinpune from './pages/Ertiga Cab Hire in Pune';
import Swiftdzireonrentinpune from './pages/Swift Dzire on Rent in Pune';
import Sedancabserviceiinpune from './pages/Sedan Cab Service in Pune';
import Sevanseatercar from './pages/7 Seater Car on Rent in Pune';
import Etioncabforoutstation from './pages/Etios Cab for Outstation in Pune';
import Jejuricabbooking from './pages/Pune to Jejuri Cab Booking';
import Punedarshanpackagecab from './pages/Pune Darshan Package Cab Booking';
import Punetoindorecabservice from './pages/Pune to Indore Cab Service';
import Punetogujratcabservice from './pages/Pune to Gujarat Cab Service';
import Punetorajsthancab from './pages/Pune to Rajasthan Cab Online Booking';
import Punetobanglorecab from './pages/Pune to Bangalore Cab Fare';
import Punetoshirdicabroundtrip from './pages/Pune to Shirdi Cab Round Trip';
import Bookcabinpuneforoutstation from './pages/Book Cab in Pune for Outstation';
import Punetomahabaleshwartaxiservice from './pages/Pune to Mahabaleshwar Taxi Service';
import Punetogoacabpackages from './pages/Pune to Goa Cab Package';
import Punetomumbaicabservice from './pages/Pune to Mumbai Cab Service';
import Punetoaurangabadcabbooking from './pages/Pune to Aurangabad Cab Booking';
import Corporatecarrentalserviceinpune from './pages/Corporate Car Rental Services in Pune';
import Luxurycaronrentforweddinginpune from './pages/Luxury Car on Rent for Wedding in Pune';
import Taxiserviceinpimprichichwadpune from './pages/Taxi Service in Pimpri Chinchwad Pune';
import Panindiabusandcabservice from './pages/Pan India Bus & Cab Service Pune';
import Punetomysoreootybustour from './pages/Pune to Mysore Ooty Bus Tour Package';
import Punetomadhyapradeshbus from './pages/Pune to Madhya Pradesh Bus for Trip';
import Busonrentforlocalpartyinpune from './pages/Bus on Rent for Local Party in Pune';
import Busrentalforweddinginpimprichichwad from './pages/Bus Rental for Wedding in Pimpri Chinchwad';
import Busrentformarriageinpune from './pages/Bus Rent for Marriage in Pune';
import Busrentalforcorporateeventsinpune from './pages/Bus Rental for Corporate Events in Pune';
import Busrentalforpicnicinpune from './pages/Bus Rental for Picnic in Pune';
import Fournineseaterbusonrent from './pages/49 Seater Bus on Rent in Pune';
import Twozeroseaterbusonrentinpune from './pages/20 Seater Bus on Rent in Pune';
import Twosixseaterbus from './pages/26 Seater Bus on Rent in Pune';
import Threetwoseatertempotraveller from './pages/32 Seater Tempo Traveller Service in Pune';
import Threesixseaterbus from './pages/36 Seater Bus on Rent in Pune';
import Fourzerobusonrent from './pages/40 Seater Bus On Rent in Mumbai';
import Punetoujjaindarshanbusonrent from './pages/Pune to Ujjain Darshan Bus On Rent';
import Shirdicarrentalservice from './pages/Shirdi Car Rental Service';
import Besttaxiserviceinshirdi from './pages/Best Taxi Service in Shirdi';
import Daundtoshirdicabservice from './pages/Daund to Shirdi Cab Service';
import Daundtoshirdishingnapurcab from './pages/Daund to Shani Shingnapur Cab Service';
import Punetoshegaonbusonrental from './pages/Pune to Shegaon Bus on Rental';
import Daundtoshirditaxixab from './pages/Daund to Shirdi Taxi Cab Bus Hire Online Booking';
import Daundtoshirdicabbooking from './pages/Daund to Shirdi Cab Booking';
import Daundstationcabbooking from './pages/Daund Station Cab Booking';
import Cabserviceindaund from './pages/Cab Service in Daund';
import Daundtoshirdicabs from './pages/Daund to Shirdi Cabs';
import Daundrailwaystationtoshirdibusonrent from './pages/Daund Railway Station to Shirdi Bus On Rent';
import Daundjunctiontoshirdi from './pages/Daund Junction to Shirdi AC Bus On Rentals';
import Innovacrystaonrentindaund from './pages/Innova Crysta On Rent in Daund';
import Ertigacabhireindaund from './pages/Ertiga Cab Hire in Daund';
import Swiftdzireonrentindaund from './pages/Swift Dzire On Rent in Daund';
import Tempotravelleronrentindaund from './pages/Tempo Traveller On Rent in Daund Junction';
import Urbaniaonrentindaund from './pages/Urbania On Rent in Daund';
import Corporatebushireindaund from './pages/Corporate Bus Hire in Daund';
import Cabserviceinkurkumbhmidc from './pages/Cab Service in Kurkumbh MIDC';
import Thirtintwobusonrentinshirdi from './pages/32 Seater Bus on Rent in Shirdi';
import Fiveseateronrentinshirdi from './pages/5 Seater Bus on Rent in Shirdi';
import Miniacbusonrentinshirdi from './pages/Mini AC Bus on Rent in Shirdi';
import Onesevanseaterbusonrentindaund from './pages/17 Seater Bus On Rent in Daund Pune';
import Twozeroseaterbusonrentindaund from './pages/20 Seater Bus on Rent in Daund';
import Threetwoseaterbusonrentindaund from './pages/32 Seater Bus on Rent in Daund';
import Threefiveseaterbusonrentindaund from './pages/35 Seater Bus on Rent in Daund';
import Fourzeroseaterbusonrent from './pages/40 Seater Bus on Rent in Daund';
import Fourfiveseaterbusonrentindaund from './pages/45 Seater Bus on Rent in Daund';
import Fivezeroseaterbusonrentindaund from './pages/50 Seater Bus on Rent in Daund';
import Daundtosolapurbusonrentpune from './pages/Daund to Solapur Bus On Rent Pune';
import Daundtomahabaleshwarbusonrent from './pages/Daund to Mahabaleshwar Bus On Rent';
import Daundtokonkandarshanbus from './pages/Daund to Konkan Darshan Bus On Rent';
import Onlinecabbookingdaund from './pages/Online Cab Booking Daund';
import Ertigarentindaundpune from './pages/Ertiga Rent in Daund Pune';
import Minibusonrentinmagarpatta from './pages/Mini Bus On Rent in Magarpatta City';
import Corporatebushirehadapsar from './pages/Corporate Bus Hire Hadapsar Pune';
import Daundbusrentalserice from './pages/Daund Bus Rental Service';
import Daundbushirerentalservice from './pages/Daund Bus Hire Rental Service';
import Monthlybushireindaund from './pages/Monthly Bus Hire in Daund';
import Punetohyderabadbusonrent from './pages/Pune to Hyderabad Bus On Rent';
import Daundtotrimbkeshwarbusonrent from './pages/Daund to Trimbakeshwar Bus On Rent';
import Daundtogrishneshwarbusonrent from './pages/Daund to Grishneshwar Bus On Rent';
import Daundtomorgaoncabservice from './pages/Daund to Morgaon Cab Service';
import Daundtosiddhatekdarshanbus from './pages/Daund to Siddhatek Darshan Bus On Rent';
import Bookdaundtoshirdixabonhire from './pages/Book Daund to Shirdi Cab on Hire';
import Busonrentinhavelipune from './pages/Bus On Rent in Haveli Pune';
import Bushireinpimprichichwad from './pages/Bus Hire in Pimpri Chinchwad';
import Cabserviceinpimprichichwad from './pages/Cab Service in Pimpri Chinchwad';
import Bushireinmulshi from './pages/Bus Hire in Mulshi';
import Cabserviceinmulshipune from './pages/Cab Service in Mulshi Pune';
import Busonrentinmaval from './pages/Bus On Rent in Maval';
import Cabserviceinmaval from './pages/Cab Service in Maval';
import Busonrentinkhed from './pages/Bus On Rent in Khed';
import Busonrentinshirur from './pages/Bus On Rent in Shirur';
import Cabserviceinshirur from './pages/Cab Service in Shirur';
import Outstationbushireinbaramati from './pages/Outstation Bus Hire in Baramati';
import Cabserviceinbaramati from './pages/Cab Service in Baramati';
import Busonrentinindapur from './pages/Bus On Rent in Indapur';
import Buscabserviceinindapur from './pages/Best Cab Service in Indapur';
import Busonrentinpurandar from './pages/Bus On Rent in Purandar';
import Busonrentinpurandarairports from './pages/Bus On Rent in Purandar Airport';
import Cabserviceinpurandar from './pages/Cab Service in Purandar';
import Corporatecabserviceinpurandar from './pages/Corporate Cab Service in Purandar Airport';
import Busonhireinbhor from './pages/Bus On Hire in Bhor';
import Cabserviceinbhor from './pages/Cab Service in Bhor';
import Busonrentinvelhepune from './pages/Bus On Rent in Velhe Pune';
import Cabserviceinvelhepune from './pages/Cab Service in Velhe Pune';
import Busonrentinjunnarpune from './pages/Bus On Rent in Junnar Pune';
import Cabserviceinjunnartaluka from './pages/Cab Service in Junnar Taluka';
import Busonrentinambegaonpune from './pages/Bus On Rent in Ambegaon Pune';
import Cabserviceinambegaontaluka from './pages/Cab Service in Ambegaon Taluka';
import Luxurybusonrentinmancharpune from './pages/Luxury Bus on Rent in Manchar Pune';
import Busonrentinjejuripune from './pages/Bus On Rent in Jejuri Pune';
import Puneashtavinayakdarshan from './pages/Pune Ashtavinayak Darshan Tour Package';
import Punetofivejyotilingaacabpackage from './pages/Pune to 5 Jyotirlinga Cab Package';
import Solapurbusrentalservice from './pages/Solapur Bus Rental Service';
import Onesevanseaterbusonrentinsolapur from './pages/17 Seater Bus on Rent in Solapur';
import Onezeroseaterbusonrent from './pages/20 Seater Bus on Rent in Solapur';
import Onefiveseaterbusonrent from './pages/25 Seater Bus on Rent in Solapur';
import Threetwoseaterbusonrentinsolapur from './pages/32 Seater Bus on Rent in Solapur';
import Threefiveseaterbusonrentinsolapur from './pages/35 Seater Bus on Rent in Solapur';
import Fourzerobusonrentinsolapur from './pages/40 Seater Bus on Rent in Solapur';
import Fourfivebusonrentinsolapur from './pages/45 Seater Bus on Rent in Solapur';
import Fivezeroseaterbusonrentinsolapur from './pages/50 Seater Bus on Rent in Solapur';
import Busonrentinchakanpune from './pages/Bus On Rent in Chakan Pune';
import Luxurybusonrentinahmednagar from './pages/Luxury Bus on Rent in Ahmednagar';
import Onesevanseaterbusonrentinahmednagar from './pages/17 Seater Bus on Rent in Ahmednagar';
import Twozerobusonrentinahmedabad from './pages/20 Seater Bus on Rent in Ahmednagar';
import Twofiveseaterbusonrentinahmednagar from './pages/25 Seater Bus on Rent in Ahmednagar';
import Threetwoseaterbusonrentinahmednagar from './pages/32 Seater Bus on Rent in Ahmednagar';
import Threefiveseaterbusonrentinahmednagar from './pages/35 Seater Bus on Rent in Ahmednagar';
import Fourzeroseaterbusonrentinahmednagar from './pages/40 Seater Bus on Rent in Ahmednagar';
import Fourfiveseaterbusonrentinahmednagar from './pages/45 Seater Bus on Rent in Ahmednagar';
import Fivezerosetaerbusonrent from './pages/50 Seater Bus on Rent in Ahmednagar';
import Busonrentinshrigonda from './pages/Bus On Rent in Shrigonda';
import Bushireinshrigonda from './pages/Bus Hire in Shrigonda';
import Shrigondabusrental from './pages/Shrigonda Bus Rental';
import Rentabusinshrigonda from './pages/Rent a Bus in Shrigonda';
import Shrigondabushireservice from './pages/Shrigonda Bus Hire Service';
import Punetohampibadambusonrentservice from './pages/Pune to Hampi Badami Bus on Rent Services';
import Punetotirupatibalajibusrental from './pages/Pune to Tirupati Balaji Bus Rental Services';
import Punetomurudeshwarbusonrent from './pages/Pune to Murudeshwar Bus On Rent Service';
import Punetokanyakumari from './pages/Pune to Kanyakumari Bus Tour Package';
import Punetoprayagrajbusrental from './pages/Pune to Prayagraj Bus Rental Service';
import Punetogirnarbushireservice from './pages/Pune to Girnar Bus Hire Service';
import Punetojaisalmertour from './pages/Pune to Jaisalmer Tour Package';
import Punetokhatushyamtourpackage from './pages/Pune to Khatu Shyam Tour Package';
import Punetodwarkabusonrent from './pages/Pune Dwarka Bus On Rent';
import Punetoayodhyatourpackages from './pages/Pune to Ayodhya Tour Package';
import ContactButtons from './componets/ContactButtons';
import Busonrentinvarvandpune from './pages/Bus On Rent in Varvand Pune';
import Busonrentinkedgaonchaufla from './pages/Bus On Rent in Kedgaon Chaufula';
import Bushireinpatasdaund from './pages/Bus Hire in Patas Daund';
import Busonrentindaundpune from './pages/Bus On Rent in Daund Pune';
import Bushireindaundpune from './pages/Bus Hire in Daund Pune';
import Busonrentinkurkumbhmidc from './pages/Bus On Rent In Kurkumbh MIDC';
import Bushireinkashtishrigonda from './pages/Bus Hire in Kashti Shrigonda';
import Bushireinmandavganpharatapune from './pages/Bus Hire in Mandavgan Pharata Pune';
import Busonrentpargaondaund from './pages/Bus On Rent Pargaon Daund';
import Busonrentinpunesolapurhighway from './pages/Bus On Rent in Pune Solapur Highway';
import Bushireinrahudaundpune from './pages/Bus Hire in Rahu Daund Pune';
import Busonrentinkhutbavpune from './pages/Bus On Rent in Khutbav Pune';
import Bushireinyavatpune from './pages/Bus Hire in Yavat Pune';
import Busonrentinurulikanchanpune from './pages/Bus On Rent in Uruli Kanchan Pune';
import Busonrentinbhandgaonpune from './pages/Bus On Rent in Bhandgaon Pune';
import Bushireinbhigwanpune from './pages/Bus Hire in Bhigwan Pune';
import Busonrentinkhadkibhigwan from './pages/Bus On Rent in Khadki Bhigwan';
import Busonrentinsiddhatekganpati from './pages/Bus On Rent in Siddhatek Ganpati';
import Busonrentinmorgaonsupe from './pages/Bus On Rent in Morgaon Supe';
import Bushireinbaramati from './pages/Bus Hire in Baramati';
import Busonrentinravangaondaund from './pages/Bus On Rent in Ravangaon Daund';
import Busonrentinboribel from './pages/Bus On Rent in Boribel';
import Busonrentinnhavareshirur from './pages/Bus On Rent in Nhavare Shirur';
import Busonrentinranjangaonmidc from './pages/Bus On Rent in Ranjangaon MIDC';
import Busonrentinkaregaonmidc from './pages/Bus On Rent in Karegaon MIDC';
import Busonrentinhadapsarpune from './pages/Bus On Rent in Hadapsar Pune';
import Busonrentinbhorepune from './pages/Bus On Rent in Bhor Pune';
import Bushireinpune from './pages/Bus Hire in Pune';
import Bushireforweddingpune from './pages/Bus Hire for Wedding Pune';
import Acbushireinpune from './pages/AC Bus Hire in Pune';
import Sevantinseaterbusrentalpune from './pages/17 Seater Bus Rental Pune';
import Threetwoseaterbusrentalpune from './pages/32 Seater Bus Rental Pune';
import Punetomumbaibusonhire from './pages/Pune to Mumbai Bus on Hire';
import Onewaycabservicepune from './pages/One Way Cab Service Pune';
import Ertigacabbookinginpune from './pages/Ertiga Cab Booking in Pune';
import Kiacarensonrentinpune from './pages/Kia Carens On Rent in Pune';
import Sedancabsbookinginpune from './pages/Sedan Cabs Booking in Pune';
import Forceurbaniaonrentinpune from './pages/Force Urbania On Rent in Pune';
import Fortuneronrentinpune from './pages/Fortuner On Rent in Pune';
import Corporatecabserviceinpune from './pages/Corporate Cab Services in Pune';
import Innovacrystaonrentinpuneforcorporate from './pages/Innova Crysta On Rent in Pune for Corporate Events';
import Urbaniaonrentinpuneforcorporate from './pages/Urbania On Rent in Pune for Corporate';
import Corporatecabserviceinpuneairport from './pages/Corporate Cab Service in Pune Airport';
import Monthlycabserviceinpimprichichwad from './pages/Monthly Cab Service in Pimpri Chinchwad';
import Corporatecabserviceinhinjewadi from './pages/Corporate Cab Service in Hinjewadi';
import Cabsforcorporatepicnicinpune from './pages/Cabs for Corporate Picnic in Pune';
import Cabserviceinhinjewadiitpark from './pages/Cab Service in Hinjewadi IT Park';
import Cabserviceinchichwadpune from './pages/Cab Service in Chinchwad Pune';
import Swiftdzireserviceinkharadiitpark from './pages/Swift Dzire Service in Kharadi IT Park';
import Cabserviceinhadapsarpune from './pages/Cab Service in Hadapsar Pune';
import Busonrentformahabaleshwar from './pages/Bus on Rent for Mahabaleshwar Picnic';
import Tempotravellerforshirdidarshan from './pages/Tempo Traveller for Shirdi Darshan';
import Punetopandharpur from './pages/Pune to Pandharpur Bus on Rent';
import Acbushireforjejuridarshan from './pages/AC Bus Hire for Jejuri Darshan';
import Luxurybusrentalforalandiyatra from './pages/Luxury Bus Rental for Alandi Yatra';
import Minibusonrentfortuljapurtrip from './pages/Mini Bus on Rent for Tuljapur Trip';
import Twentyzeroseatertempotraveller from './pages/20 Seater Tempo Traveller for Bhimashankar';
import Busonrentforgrouptravelpune from './pages/Bus on Rent for Group Travel Pune';
import Bushireforoutstationpune from './pages/Bus Hire for Outstation Pune';
import Tempotravelleronrentforpicnicpune from './pages/Tempo Traveller on Rent for Picnic Pune';
import Volvobusonrentinpuneforkolhapurdarshan from './pages/Volvo Bus on Rent in Pune for Kolhapur Darshan';
import Twozeroseaterbushireinpune from './pages/20 Seater Bus Hire in Pune';
import Touristbushirepune from './pages/Tourist Bus Hire Pune';
import Volvobushireinpune from './pages/Volvo Bus Hire in Pune';
import Fiftyzeroseaterbusonrentpune from './pages/50 Seater Bus on Rent Pune';
import Bushireforashavinayakdarshan from './pages/Bus Hire for Ashtavinayak Darshan';
import Onethreeseatertempolavasa from './pages/13 Seater Tempo Traveller for Lavasa Tour';
import Punetotrimbkeshwarbusrental from './pages/Pune to Trimbakeshwar Bus Rental';
import Tempotravellerforfivejyotilinga from './pages/Tempo Traveller for 5 Jyotirlinga';
import Threetwoseaterbusonrentfornashik from './pages/32 Seater Bus on Rent for Nashik Darshan';
import Privatebushireforsatartrip from './pages/Private Bus Hire for Satara Trip';
import Punetogoatempotravelleronrent from './pages/Pune to Goa Tempo Traveller on Rent';
import Bushireforkonkantourpackage from './pages/Bus Hire for Konkan Tour Package';
import Volvobusforfamilytourpune from './pages/Volvo Bus for Family Tour Pune';
import Touristbusrentalforsinhagadfort from './pages/Tourist Bus Rental for Sinhagad Fort Trip';
import Nonacbusforcollegepicnicpune from './pages/Non AC Bus for College Picnic Pune';
import Staffbusrentalforpunecompanies from './pages/Staff Bus Rental for Pune Companies';
import Busonrentforpunecitytour from './pages/Bus on Rent for Pune City Tour';
import Busonrentforweekendgatewaypune from './pages/Bus on Rent for Weekend Getaway Pune';
import Acminibusforrouppicnicpune from './pages/AC Mini Bus for Group Picnic Pune';
import Fivezeroseaterbusonrentforschool from './pages/50 Seater Bus on Rent for School Trip Pune';
import Busonrentforharihareshwar from './pages/Bus on Rent for Harihareshwar';
import Twofiveseaterbusforganpatipule from './pages/25 Seater Bus for Ganpatipule';
import Tempotravellerhirefortarkari from './pages/Tempo Traveller Hire for Tarkarli';
import Minibusonrentformatheranpune from './pages/Mini Bus on Rent for Matheran Pune';
import Busonrentforbhimashankarwildlife from './pages/Bus on Rent for Bhimashankar Wildlife';
import Bushireforranjangaonmahaganpati from './pages/Bus Hire for Ranjangaon Mahaganpati';
import Busrentalforajantaellora from './pages/Bus Rental for Ajanta Ellora';
import Volvobuspuneforaurangabadsightseeing from './pages/Volvo Bus Pune for Aurangabad Sightseeing';
import Onesevanseatertempotravellernighojpotholes from './pages/17 Seater Tempo Traveller Nighoj Potholes Bus Trip';
import Volvobushireforkhandala from './pages/Volvo Bus Hire for Khandala';
import Tempotravellerrentalforcorporatepicnic from './pages/Tempo Traveller Rental for Corporate Picnic';
import Punecitydailycabservice from './pages/Pune City Daily Cab Service';
import Onesevantempo from './pages/17 Seater Tempo Traveller for Konkan Darshan';
import Schoolbusonrentinpune from './pages/School Bus on Rent in Pune';
import Bushireforcorporateevents from './pages/Bus Hire for Corporate Events Pune';
import Luxurybushireinpune from './pages/Luxury Bus Hire in Pune';
import Minibusrentalinpune from './pages/Mini Bus Rental in Pune';
import Bushireforschoolpicnininpune from './pages/Bus Hire for School Picnic in Pune';



function App() {
  return (
    <Router>
<Header/>
      <ContactButtons />
      {/* <ScrollToTop /> */}

      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services" element={<ServicesSection />} />
        <Route path="/our-fleet" element={<Ourfleets />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/network" element={<OurNetwork />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact-us" element={<ContactSection />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/tempo-traveller-on-rent-in-pune" element={<Tempotravelleronrentinpune />} />
    

<Route path="/pune-to-shirdi-tempo-traveller-on-rent" element={<Punetoshirditempotraveller />} />
<Route path="/pune-to-mahabaleshwar-tempo-traveller-on-rent" element={<Punetomahabaleshwar />} />
<Route path="/pune-to-goa-tempo-traveller-hire" element={<Punetogoatempotraveller />} />
<Route path="/pune-to-mumbai-tempo-traveller-on-rent" element={<Punetomumbaitempotraveller />} />
<Route path="/pune-to-konkan-darshan-tempo-traveller-hire" element={<Punetokonkandarshantempo />} />
<Route path="/pune-to-nashik-tempo-traveller-on-rent" element={<Punetonashiktempotravelleer />} />
<Route path="/tempo-traveller-on-rent-for-pune-darshan" element={<Tempotravelleronrentforpune />} />
<Route path="/mini-bus-on-rent-in-pune" element={<Minibusonrentinpune />} />
<Route path="/13-seater-tempo-traveller-on-rent-in-pune" element={<Onethreeseatertempo />} />
<Route path="/17-seater-tempo-traveller-on-rent-in-pune" element={<Onesevanseater />} />
<Route path="/20-seater-luxury-bus-on-rent-pune" element={<Twentyseaterluxurybusonrent />} />
<Route path="/26-seater-tempo-traveller-on-rent-in-pune" element={<Twentisixseatertempotraveller />} />
<Route path="/32-seater-luxury-bus-on-rent-in-pune" element={<Thietintwoseaterluxurybusonrent />} />
<Route path="/35-seater-bus-on-rent-in-pune" element={<Threefiveseaterbusonrentinpune />} />
<Route path="/45-seater-bus-on-rent-in-pune" element={<Fourfiveseaterbusonrentinpune />} />
<Route path="/50-seater-bus-on-rent-in-pune" element={<Fivezeroseaterbusonrentinpune />} />
<Route path="/bus-hire-for-school-trips-in-pune" element={<Bushireforschooltripinpune />} />
<Route path="/bus-booking-for-wedding-in-pune" element={<Busbookingforweddinginpune />} />
<Route path="/bus-booking-for-marriage-in-pune" element={<Busbookingformarriage />} />
<Route path="/bus-service-for-corporate-in-pune" element={<Busserviceforcorporateinpune />} />
<Route path="/bus-on-rent-for-event-in-pune" element={<Busonrentforeventinpune />} />
<Route path="/bus-hire-for-outstation-in-pune" element={<Bushireforoutstationinpune />} />
<Route path="/ac-bus-on-rent-in-pune" element={<Acbusonrentinpune />} />
<Route path="/pune-bus-hire-rental-service" element={<Punebushirerrentalservice />} />
<Route path="/non-ac-bus-rental-service-in-pune" element={<Nonacbusrentalserviceinpune />} />
<Route path="/bus-service-for-picnic-in-pune" element={<Busserviceforpicniicinpune />} />

<Route path="/pune-to-aurangabad-tempo-traveller-on-rent" element={<Punetoaurangabadtempotraveller />} />
<Route path="/ashtavinayak-darshan-tour-bus-package-from-pune" element={<Ashtavinayakdarshantourbuspackage />} />
<Route path="/pune-to-rajasthan-bus-trip-package" element={<Punetorajshtanbustrippackage />} />
<Route path="/pune-to-gujarat-bus-hire-package" element={<Punetogijratbushirepackage />} />
<Route path="/goa-tour-package-from-pune-by-bus" element={<Goatourpackagefrompune />} />
<Route path="/pune-to-uttar-pradesh-bus-on-rent" element={<Punetouttarpradeshbusonrent />} />
<Route path="/book-konkan-darshan-tour-packages-from-pune-by-bus" element={<Bookkonkandarshantourpackage />} />
<Route path="/local-bus-hire-in-pune" element={<Localbushireinpune />} />
<Route path="/pune-to-lonavala-bus-tour-package" element={<Punetolonavalabustourpackage />} />
<Route path="/pune-to-nashik-bus-on-rent-packages" element={<Punetonashikbusonrentpackage />} />
<Route path="/luxury-12-14-17-seater-tempo-traveller-in-pune" element={<Luxuryontwoseater />} />
<Route path="/bus-hire-for-tourist-in-pune" element={<Bushirefortoristinpune />} />
<Route path="/pune-to-sinhagad-fort-bus-on-rent-in-pune" element={<Punetosinhagadfortbusonrent />} />
<Route path="/pune-to-bhimashankar-jyotirlinga-bus-on-rent" element={<Punetobhimashankarjtotilinga />} />
<Route path="/pune-to-kolhapur-tempo-traveller-rent" element={<Punetokolhapurtempo />} />
<Route path="/pune-to-mumbai-bus-hire-for-tour-package" element={<Punetomumbaibushirefortour />} />
<Route path="/sade-teen-shakti-peeth-tour-from-pune-by-bus-package" element={<Sadeteenshaktipeethtourfrom />} />
<Route path="/pune-to-matheran-tempo-traveller-hire-on-rent" element={<Punetomatherantempotraveller />} />
<Route path="/ac-tempo-traveller-on-rent-in-pune" element={<Actempotravelleronrent />} />
<Route path="/bus-hire-in-pune-for-outstation-and-local-trip" element={<Bushireinpuneforoutstationandlocal />} />
<Route path="/book-bus-on-rent-in-pune" element={<Bookbusonrentinpune />} />
<Route path="/bharat-benz-bus-on-rent-in-pune" element={<Bharatbenzbusonrentinpune />} />
<Route path="/eicher-bus-on-rent-in-pune" element={<Eicherbusonrentinpune />} />
<Route path="/pune-to-mahabaleshwar-cab-package" element={<Punetomahabaleshwarcabpackage />} />
<Route path="/pune-to-bhimashankar-cab-package" element={<Punetobhimashankarcabpackage />} />
<Route path="/pune-to-konkan-darshan-cabs" element={<Punetokonkankadarshancabs />} />
<Route path="/online-cab-booking-pune" element={<Onlinecabbookingpune />} />
<Route path="/innova-crysta-cab-booking-in-pune" element={<Innovacrystacabbookinginpune />} />
<Route path="/ashtavinayak-darshan-cab-pune" element={<Ashtavinayakdarshancab />} />
<Route path="/pune-to-lonavala-cab-service" element={<Punetolonavalacabservice />} />
<Route path="/pune-to-outstation-cabs-package" element={<Punetooutstationcabspackages />} />
<Route path="/ertiga-cab-hire-in-pune" element={<Ertigacabhireinpune />} />
<Route path="/swift-dzire-on-rent-in-pune" element={<Swiftdzireonrentinpune />} />
<Route path="/sedan-cab-service-in-pune" element={<Sedancabserviceiinpune />} />
<Route path="/7-seater-car-on-rent-in-pune" element={<Sevanseatercar />} />
<Route path="/etios-cab-for-outstation-in-pune" element={<Etioncabforoutstation />} />
<Route path="/pune-to-jejuri-cab-booking" element={<Jejuricabbooking />} />
<Route path="/pune-darshan-package-cab-booking" element={<Punedarshanpackagecab />} />


<Route path="/pune-to-indore-cab-service" element={<Punetoindorecabservice />} />
<Route path="/pune-to-gujarat-cab-service" element={<Punetogujratcabservice />} />
<Route path="/pune-to-rajasthan-cab-online-booking" element={<Punetorajsthancab />} />
<Route path="/pune-to-bangalore-cab-fare" element={<Punetobanglorecab />} />
<Route path="/pune-to-shirdi-cab-round-trip" element={<Punetoshirdicabroundtrip />} />

<Route path="/book-cab-in-pune-for-outstation" element={<Bookcabinpuneforoutstation />} />
<Route path="/pune-to-mahabaleshwar-taxi-service" element={<Punetomahabaleshwartaxiservice />} />
<Route path="/pune-to-goa-cab-package" element={<Punetogoacabpackages />} />
<Route path="/pune-to-mumbai-cab-service" element={<Punetomumbaicabservice />} />
<Route path="/pune-to-aurangabad-cab-booking" element={<Punetoaurangabadcabbooking />} />
<Route path="/corporate-car-rental-services-in-pune" element={<Corporatecarrentalserviceinpune />} />
<Route path="/luxury-car-on-rent-for-wedding-in-pune" element={<Luxurycaronrentforweddinginpune />} />
<Route path="/taxi-service-in-pimpri-chinchwad-pune" element={<Taxiserviceinpimprichichwadpune />} />
<Route path="/pan-india-bus-and-cab-service-pune" element={<Panindiabusandcabservice />} />
<Route path="/pune-to-mysore-ooty-bus-tour-package" element={<Punetomysoreootybustour />} />
<Route path="/pune-to-madhya-pradesh-bus-for-trip" element={<Punetomadhyapradeshbus />} />
<Route path="/bus-on-rent-for-local-party-in-pune" element={<Busonrentforlocalpartyinpune />} />
<Route path="/bus-rental-for-wedding-in-pimpri-chinchwad" element={<Busrentalforweddinginpimprichichwad />} />
<Route path="/bus-rent-for-marriage-in-pune" element={<Busrentformarriageinpune />} />
<Route path="/bus-rental-for-corporate-events-in-pune" element={<Busrentalforcorporateeventsinpune />} />
<Route path="/bus-rental-for-picnic-in-pune" element={<Busrentalforpicnicinpune />} />
<Route path="/49-seater-bus-on-rent-in-pune" element={<Fournineseaterbusonrent />} />
<Route path="/20-seater-bus-on-rent-in-pune" element={<Twozeroseaterbusonrentinpune />} />
<Route path="/26-seater-bus-on-rent-in-pune" element={<Twosixseaterbus />} />
<Route path="/32-seater-tempo-traveller-service-in-pune" element={<Threetwoseatertempotraveller />} />
<Route path="/36-seater-bus-on-rent-in-pune" element={<Threesixseaterbus />} />
<Route path="/40-seater-bus-on-rent-in-mumbai" element={<Fourzerobusonrent />} />

<Route path="/pune-to-ujjain-darshan-bus-on-rent" element={<Punetoujjaindarshanbusonrent />} />
<Route path="/shirdi-car-rental-service" element={<Shirdicarrentalservice />} />
<Route path="/best-taxi-service-in-shirdi" element={<Besttaxiserviceinshirdi />} />
<Route path="/daund-to-shirdi-cab-service" element={<Daundtoshirdicabservice />} />
<Route path="/daund-to-shani-shingnapur-cab-service" element={<Daundtoshirdishingnapurcab />} />
<Route path="/pune-to-shegaon-bus-on-rental" element={<Punetoshegaonbusonrental />} />
<Route path="/daund-to-shirdi-taxi-cab-bus-hire-online-booking" element={<Daundtoshirditaxixab />} />
<Route path="/daund-to-shirdi-cab-booking" element={<Daundtoshirdicabbooking />} />
<Route path="/daund-station-cab-booking" element={<Daundstationcabbooking />} />
<Route path="/cab-service-in-daund" element={<Cabserviceindaund />} />
<Route path="/daund-to-shirdi-cabs" element={<Daundtoshirdicabs />} />
<Route path="/daund-railway-station-to-shirdi-bus-on-rent" element={<Daundrailwaystationtoshirdibusonrent />} />
<Route path="/daund-junction-to-shirdi-ac-bus-on-rentals" element={<Daundjunctiontoshirdi />} />
<Route path="/innova-crysta-on-rent-in-daund" element={<Innovacrystaonrentindaund />} />
<Route path="/ertiga-cab-hire-in-daund" element={<Ertigacabhireindaund />} />
<Route path="/swift-dzire-on-rent-in-daund" element={<Swiftdzireonrentindaund />} />
<Route path="/tempo-traveller-on-rent-in-daund-junction" element={<Tempotravelleronrentindaund />} />
<Route path="/urbania-on-rent-in-daund" element={<Urbaniaonrentindaund />} />
<Route path="/corporate-bus-hire-in-daund" element={<Corporatebushireindaund />} />
<Route path="/cab-service-in-kurkumbh-midc" element={<Cabserviceinkurkumbhmidc />} />
<Route path="/32-seater-bus-on-rent-in-shirdi" element={<Thirtintwobusonrentinshirdi />} />
<Route path="/5-seater-bus-on-rent-in-shirdi" element={<Fiveseateronrentinshirdi />} />
<Route path="/mini-ac-bus-on-rent-in-shirdi" element={<Miniacbusonrentinshirdi />} />
<Route path="/17-seater-bus-on-rent-in-daund-pune" element={<Onesevanseaterbusonrentindaund />} />
<Route path="/20-seater-bus-on-rent-in-daund" element={<Twozeroseaterbusonrentindaund />} />
<Route path="/32-seater-bus-on-rent-in-daund" element={<Threetwoseaterbusonrentindaund />} />
<Route path="/35-seater-bus-on-rent-in-daund" element={<Threefiveseaterbusonrentindaund />} />
<Route path="/40-seater-bus-on-rent-in-daund" element={<Fourzeroseaterbusonrent />} />
<Route path="/45-seater-bus-on-rent-in-daund" element={<Fourfiveseaterbusonrentindaund />} />
<Route path="/50-seater-bus-on-rent-in-daund" element={<Fivezeroseaterbusonrentindaund />} />
<Route path="/daund-to-solapur-bus-on-rent-pune" element={<Daundtosolapurbusonrentpune />} />
<Route path="/daund-to-mahabaleshwar-bus-on-rent" element={<Daundtomahabaleshwarbusonrent />} />
<Route path="/daund-to-konkan-darshan-bus-on-rent" element={<Daundtokonkandarshanbus />} />
<Route path="/online-cab-booking-daund" element={<Onlinecabbookingdaund />} />
<Route path="/ertiga-on-rent-in-daund-pune" element={<Ertigarentindaundpune />} />
<Route path="/mini-bus-on-rent-in-magarpatta-city" element={<Minibusonrentinmagarpatta />} />
<Route path="/corporate-bus-hire-hadapsar-pune" element={<Corporatebushirehadapsar />} />
<Route path="/daund-bus-rental-service" element={<Daundbusrentalserice />} />



<Route path="/daund-bus-hire-rental-service" element={<Daundbushirerentalservice />} />
<Route path="/monthly-bus-hire-in-daund" element={<Monthlybushireindaund />} />
<Route path="/pune-to-hyderabad-bus-on-rent" element={<Punetohyderabadbusonrent />} />
<Route path="/daund-to-trimbakeshwar-bus-on-rent" element={<Daundtotrimbkeshwarbusonrent />} />
<Route path="/daund-to-grishneshwar-bus-on-rent" element={<Daundtogrishneshwarbusonrent />} />
<Route path="/daund-to-morgaon-cab-service" element={<Daundtomorgaoncabservice />} />
<Route path="/daund-to-siddhatek-darshan-bus-on-rent" element={<Daundtosiddhatekdarshanbus />} />

<Route path="/book-daund-to-shirdi-cab-on-hire" element={<Bookdaundtoshirdixabonhire />} />
<Route path="/bus-on-rent-in-haveli-pune" element={<Busonrentinhavelipune />} />
<Route path="/bus-hire-in-pimpri-chinchwad" element={<Bushireinpimprichichwad />} />
<Route path="/cab-service-in-pimpri-chinchwad" element={<Cabserviceinpimprichichwad />} />
<Route path="/bus-hire-in-mulshi" element={<Bushireinmulshi />} />
<Route path="/cab-service-in-mulshi-pune" element={<Cabserviceinmulshipune />} />
<Route path="/bus-on-rent-in-maval" element={<Busonrentinmaval />} />
<Route path="/cab-service-in-maval" element={<Cabserviceinmaval />} />
<Route path="/bus-on-rent-in-khed-rajgurunagar" element={<Busonrentinkhed />} />
<Route path="/bus-on-rent-in-shirur" element={<Busonrentinshirur />} />
<Route path="/cab-service-in-shirur" element={<Cabserviceinshirur />} />
<Route path="/outstation-bus-hire-in-baramati" element={<Outstationbushireinbaramati />} />
<Route path="/cab-service-in-baramati" element={<Cabserviceinbaramati />} />
<Route path="/bus-on-rent-in-indapur" element={<Busonrentinindapur />} />
<Route path="/best-cab-service-in-indapur" element={<Buscabserviceinindapur />} />
<Route path="/bus-on-rent-in-purandar" element={<Busonrentinpurandar />} />
<Route path="/bus-on-rent-in-purandar-airport" element={<Busonrentinpurandarairports />} />
<Route path="/cab-service-in-purandar" element={<Cabserviceinpurandar />} />
<Route path="/corporate-cab-service-in-purandar-airport" element={<Corporatecabserviceinpurandar />} />
<Route path="/bus-on-hire-in-bhor" element={<Busonhireinbhor />} />
<Route path="/cab-service-in-bhor" element={<Cabserviceinbhor />} />
<Route path="/bus-on-rent-in-velhe-pune" element={<Busonrentinvelhepune />} />
<Route path="/cab-service-in-velhe-pune" element={<Cabserviceinvelhepune />} />
<Route path="/bus-on-rent-in-junnar-pune" element={<Busonrentinjunnarpune />} />
<Route path="/cab-service-in-junnar-taluka" element={<Cabserviceinjunnartaluka />} />
<Route path="/bus-on-rent-in-ambegaon-pune" element={<Busonrentinambegaonpune />} />
<Route path="/cab-service-in-ambegaon-taluka" element={<Cabserviceinambegaontaluka />} />
<Route path="/luxury-bus-on-rent-in-manchar-pune" element={<Luxurybusonrentinmancharpune />} />
<Route path="/bus-on-rent-in-jejuri-pune" element={<Busonrentinjejuripune />} />
<Route path="/pune-ashtavinayak-darshan-tour-package" element={<Puneashtavinayakdarshan />} />
<Route path="/pune-to-5-jyotirlinga-cab-package" element={<Punetofivejyotilingaacabpackage />} />
<Route path="/solapur-bus-rental-service" element={<Solapurbusrentalservice />} />
<Route path="/17-seater-bus-on-rent-in-solapur" element={<Onesevanseaterbusonrentinsolapur />} />
<Route path="/20-seater-bus-on-rent-in-solapur" element={<Onezeroseaterbusonrent />} />
<Route path="/25-seater-bus-on-rent-in-solapur" element={<Onefiveseaterbusonrent />} />
<Route path="/32-seater-bus-on-rent-in-solapur" element={<Threetwoseaterbusonrentinsolapur />} />
<Route path="/35-seater-bus-on-rent-in-solapur" element={<Threefiveseaterbusonrentinsolapur />} />
<Route path="/40-seater-bus-on-rent-in-solapur" element={<Fourzerobusonrentinsolapur />} />
<Route path="/45-seater-bus-on-rent-in-solapur" element={<Fourfivebusonrentinsolapur />} />
<Route path="/50-seater-bus-on-rent-in-solapur" element={<Fivezeroseaterbusonrentinsolapur />} />
{/*  */}
<Route path="/bus-on-rent-in-chakan-pune" element={<Busonrentinchakanpune />} />
<Route path="/luxury-bus-on-rent-in-ahmednagar" element={<Luxurybusonrentinahmednagar />} />
<Route path="/17-seater-bus-on-rent-in-ahmednagar" element={<Onesevanseaterbusonrentinahmednagar />} />
<Route path="/20-seater-bus-on-rent-in-ahmednagar" element={<Twozerobusonrentinahmedabad />} />
<Route path="/25-seater-bus-on-rent-in-ahmednagar" element={<Twofiveseaterbusonrentinahmednagar />} />
<Route path="/32-seater-bus-on-rent-in-ahmednagar" element={<Threetwoseaterbusonrentinahmednagar />} />
<Route path="/35-seater-bus-on-rent-in-ahmednagar" element={<Threefiveseaterbusonrentinahmednagar />} />
<Route path="/40-seater-bus-on-rent-in-ahmednagar" element={<Fourzeroseaterbusonrentinahmednagar />} />
<Route path="/45-seater-bus-on-rent-in-ahmednagar" element={<Fourfiveseaterbusonrentinahmednagar />} />
<Route path="/50-seater-bus-on-rent-in-ahmednagar" element={<Fivezerosetaerbusonrent />} />
<Route path="/bus-on-rent-in-shrigonda" element={<Busonrentinshrigonda />} />
<Route path="/bus-hire-in-shrigonda" element={<Bushireinshrigonda />} />
<Route path="/shrigonda-bus-rental" element={<Shrigondabusrental />} />
<Route path="/rent-a-bus-in-shrigonda" element={<Rentabusinshrigonda />} />
<Route path="/shrigonda-bus-hire-service" element={<Shrigondabushireservice />} />
<Route path="/pune-to-hampi-badami-bus-on-rent-services" element={<Punetohampibadambusonrentservice />} />
<Route path="/pune-to-tirupati-balaji-bus-rental-services" element={<Punetotirupatibalajibusrental />} />
<Route path="/pune-to-murudeshwar-bus-on-rent-service" element={<Punetomurudeshwarbusonrent />} />
<Route path="/pune-to-kanyakumari-bus-tour-package" element={<Punetokanyakumari />} />
<Route path="/pune-to-prayagraj-bus-rental-service" element={<Punetoprayagrajbusrental />} />
<Route path="/pune-to-girnar-bus-hire-service" element={<Punetogirnarbushireservice />} />
<Route path="/pune-to-jaisalmer-tour-package" element={<Punetojaisalmertour />} />
<Route path="/pune-to-khatu-shyam-tour-package" element={<Punetokhatushyamtourpackage />} />
<Route path="/pune-dwarka-bus-on-rent" element={<Punetodwarkabusonrent />} />
<Route path="/pune-to-ayodhya-tour-package" element={<Punetoayodhyatourpackages />} />









<Route path="/bus-on-rent-in-varvand-pune" element={<Busonrentinvarvandpune />} />
<Route path="/bus-on-rent-in-kedgaon-chaufula" element={<Busonrentinkedgaonchaufla />} />
<Route path="/bus-hire-in-patas-daund" element={<Bushireinpatasdaund />} />
<Route path="/bus-on-rent-in-daund-pune" element={<Busonrentindaundpune />} />
<Route path="/bus-hire-in-daund-pune" element={<Bushireindaundpune />} />
<Route path="/bus-on-rent-in-kurkumbh-midc" element={<Busonrentinkurkumbhmidc />} />
<Route path="/bus-hire-in-kashti-shrigonda" element={<Bushireinkashtishrigonda />} />
<Route path="/bus-hire-in-mandavgan-pharata-pune" element={<Bushireinmandavganpharatapune />} />
<Route path="/bus-on-rent-pargaon-daund" element={<Busonrentpargaondaund />} />
<Route path="/bus-on-rent-in-pune-solapur-highway" element={<Busonrentinpunesolapurhighway />} />
<Route path="/bus-hire-in-rahu-daund-pune" element={<Bushireinrahudaundpune />} />
<Route path="/bus-on-rent-in-khutbav-pune" element={<Busonrentinkhutbavpune />} />
<Route path="/bus-hire-in-yavat-pune" element={<Bushireinyavatpune />} />
<Route path="/bus-on-rent-in-uruli-kanchan-pune" element={<Busonrentinurulikanchanpune />} />
<Route path="/bus-on-rent-in-bhandgaon-pune" element={<Busonrentinbhandgaonpune />} />
<Route path="/bus-hire-in-bhigwan-pune" element={<Bushireinbhigwanpune />} />
<Route path="/bus-on-rent-in-khadki-bhigwan" element={<Busonrentinkhadkibhigwan />} />
<Route path="/bus-on-rent-in-siddhatek-ganpati" element={<Busonrentinsiddhatekganpati />} />
<Route path="/bus-on-rent-in-morgaon-supe" element={<Busonrentinmorgaonsupe />} />
<Route path="/bus-hire-in-baramati" element={<Bushireinbaramati />} />
<Route path="/bus-on-rent-in-ravangaon-daund" element={<Busonrentinravangaondaund />} />
<Route path="/bus-on-rent-in-boribel" element={<Busonrentinboribel />} />
<Route path="/bus-on-rent-in-nhavare-shirur" element={<Busonrentinnhavareshirur />} />
<Route path="/bus-on-rent-in-ranjangaon-midc" element={<Busonrentinranjangaonmidc />} />
<Route path="/bus-on-rent-in-karegaon-midc" element={<Busonrentinkaregaonmidc />} />
<Route path="/bus-on-rent-in-hadapsar-pune" element={<Busonrentinhadapsarpune />} />
<Route path="/bus-on-rent-in-bhor-pune" element={<Busonrentinbhorepune />} />
<Route path="/bus-hire-in-pune" element={<Bushireinpune />} />
<Route path="/bus-hire-for-wedding-pune" element={<Bushireforweddingpune />} />
<Route path="/ac-bus-hire-in-pune" element={<Acbushireinpune />} />
<Route path="/17-seater-bus-rental-pune" element={<Sevantinseaterbusrentalpune />} />
<Route path="/32-seater-bus-rental-pune" element={<Threetwoseaterbusrentalpune />} />
<Route path="/pune-to-mumbai-bus-on-hire" element={<Punetomumbaibusonhire />} />
<Route path="/one-way-cab-service-pune" element={<Onewaycabservicepune />} />
<Route path="/ertiga-cab-booking-in-pune" element={<Ertigacabbookinginpune />} />
<Route path="/kia-carens-on-rent-in-pune" element={<Kiacarensonrentinpune />} />
<Route path="/sedan-cabs-booking-in-pune" element={<Sedancabsbookinginpune />} />
<Route path="/force-urbania-on-rent-in-pune" element={<Forceurbaniaonrentinpune />} />
<Route path="/fortuner-on-rent-in-pune" element={<Fortuneronrentinpune />} />
<Route path="/corporate-cab-services-in-pune" element={<Corporatecabserviceinpune />} />
<Route path="/innova-crysta-on-rent-in-pune-for-corporate-events" element={<Innovacrystaonrentinpuneforcorporate />} />
<Route path="/urbania-on-rent-in-pune-for-corporate" element={<Urbaniaonrentinpuneforcorporate />} />
<Route path="/corporate-cab-service-in-pune-airport" element={<Corporatecabserviceinpuneairport />} />
<Route path="/monthly-cab-service-in-pimpri-chinchwad" element={<Monthlycabserviceinpimprichichwad />} />
<Route path="/corporate-cab-service-in-hinjewadi" element={<Corporatecabserviceinhinjewadi />} />
<Route path="/cabs-for-corporate-picnic-in-pune" element={<Cabsforcorporatepicnicinpune />} />
<Route path="/cab-service-in-hinjewadi-it-park" element={<Cabserviceinhinjewadiitpark />} />
<Route path="/cab-service-in-chinchwad-pune" element={<Cabserviceinchichwadpune />} />
<Route path="/swift-dzire-service-in-kharadi-it-park" element={<Swiftdzireserviceinkharadiitpark />} />
<Route path="/cab-service-in-hadapsar-pune" element={<Cabserviceinhadapsarpune />} />
<Route path="/bus-on-rent-for-mahabaleshwar-picnic" element={<Busonrentformahabaleshwar />} />
<Route path="/tempo-traveller-for-shirdi-darshan" element={<Tempotravellerforshirdidarshan />} />
<Route path="/pune-to-pandharpur-bus-on-rent" element={<Punetopandharpur />} />
<Route path="/ac-bus-hire-for-jejuri-darshan" element={<Acbushireforjejuridarshan />} />
<Route path="/luxury-bus-rental-for-alandi-yatra" element={<Luxurybusrentalforalandiyatra />} />
<Route path="/mini-bus-on-rent-for-tuljapur-trip" element={<Minibusonrentfortuljapurtrip />} />
<Route path="/20-seater-tempo-traveller-for-bhimashankar" element={<Twentyzeroseatertempotraveller />} />
<Route path="/bus-on-rent-for-group-travel-pune" element={<Busonrentforgrouptravelpune />} />
<Route path="/bus-hire-for-outstation-pune" element={<Bushireforoutstationpune />} />
<Route path="/tempo-traveller-on-rent-for-picnic-pune" element={<Tempotravelleronrentforpicnicpune />} />
<Route path="/volvo-bus-on-rent-in-pune-for-kolhapur-darshan" element={<Volvobusonrentinpuneforkolhapurdarshan />} />
<Route path="/20-seater-bus-hire-in-pune" element={<Twozeroseaterbushireinpune />} />
<Route path="/tourist-bus-hire-pune" element={<Touristbushirepune />} />
<Route path="/volvo-bus-hire-in-pune" element={<Volvobushireinpune />} />
<Route path="/50-seater-bus-on-rent-pune" element={<Fiftyzeroseaterbusonrentpune />} />
<Route path="/bus-hire-for-ashtavinayak-darshan" element={<Bushireforashavinayakdarshan />} />
<Route path="/13-seater-tempo-traveller-for-lavasa-tour" element={<Onethreeseatertempolavasa />} />
<Route path="/pune-to-trimbakeshwar-bus-rental" element={<Punetotrimbkeshwarbusrental />} />
<Route path="/tempo-traveller-for-5-jyotirlinga" element={<Tempotravellerforfivejyotilinga />} />
<Route path="/32-seater-bus-on-rent-for-nashik-darshan" element={<Threetwoseaterbusonrentfornashik />} />
<Route path="/private-bus-hire-for-satara-trip" element={<Privatebushireforsatartrip />} />
<Route path="/pune-to-goa-tempo-traveller-on-rent" element={<Punetogoatempotravelleronrent />} />
<Route path="/bus-hire-for-konkan-tour-package" element={<Bushireforkonkantourpackage />} />
<Route path="/volvo-bus-for-family-tour-pune" element={<Volvobusforfamilytourpune />} />
<Route path="/tourist-bus-rental-for-sinhagad-fort-trip" element={<Touristbusrentalforsinhagadfort />} />
<Route path="/non-ac-bus-for-college-picnic-pune" element={<Nonacbusforcollegepicnicpune />} />
<Route path="/staff-bus-rental-for-pune-companies" element={<Staffbusrentalforpunecompanies />} />
<Route path="/bus-on-rent-for-pune-city-tour" element={<Busonrentforpunecitytour />} />
<Route path="/bus-on-rent-for-weekend-getaway-pune" element={<Busonrentforweekendgatewaypune />} />
<Route path="/ac-mini-bus-for-group-picnic-pune" element={<Acminibusforrouppicnicpune />} />
<Route path="/50-seater-bus-on-rent-for-school-trip-pune" element={<Fivezeroseaterbusonrentforschool />} />
<Route path="/bus-on-rent-for-harihareshwar" element={<Busonrentforharihareshwar />} />
<Route path="/25-seater-bus-for-ganpatipule" element={<Twofiveseaterbusforganpatipule />} />
<Route path="/tempo-traveller-hire-for-tarkarli" element={<Tempotravellerhirefortarkari />} />
<Route path="/mini-bus-on-rent-for-matheran-pune" element={<Minibusonrentformatheranpune />} />
<Route path="/bus-on-rent-for-bhimashankar-wildlife" element={<Busonrentforbhimashankarwildlife />} />
<Route path="/bus-hire-for-ranjangaon-mahaganpati" element={<Bushireforranjangaonmahaganpati />} />
<Route path="/bus-rental-for-ajanta-ellora" element={<Busrentalforajantaellora />} />
<Route path="/volvo-bus-pune-for-aurangabad-sightseeing" element={<Volvobuspuneforaurangabadsightseeing />} />
<Route path="/17-seater-tempo-traveller-nighoj-potholes-bus-trip" element={<Onesevanseatertempotravellernighojpotholes />} />
<Route path="/volvo-bus-hire-for-khandala" element={<Volvobushireforkhandala />} />
<Route path="/tempo-traveller-rental-for-corporate-picnic" element={<Tempotravellerrentalforcorporatepicnic />} />
<Route path="/pune-city-daily-cab-service" element={<Punecitydailycabservice />} />
<Route path="/17-seater-tempo-traveller-for-konkan-darshan" element={<Onesevantempo />} />
<Route path="/school-bus-on-rent-in-pune" element={<Schoolbusonrentinpune />} />
<Route path="/bus-hire-for-corporate-events-pune" element={<Bushireforcorporateevents />} />
<Route path="/luxury-bus-hire-in-pune" element={<Luxurybushireinpune />} />
<Route path="/mini-bus-rental-in-pune" element={<Minibusrentalinpune />} />
<Route path="/bus-hire-for-school-picnic-in-pune" element={<Bushireforschoolpicnininpune />} />




      </Routes>



      <Footer />
    </Router>
  );
}

export default App;